<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { CheckCircle2 } from 'lucide-vue-next'

const props = defineProps<{
  tags: Array<{ id: string; label: string }>
  value?: string[]
}>()
const emit = defineEmits<{ change: [change: string[]] }>()

const selected = ref<string[]>(props.value || [])

function toggle(id: string) {
  if (selected.value.includes(id)) {
    selected.value = selected.value.filter(i => i !== id)
  } else {
    selected.value.push(id)
  }
  emit('change', selected.value)
}
</script>

<template>
  <div class="flex flex-wrap gap-2 p-2 border border-gray-200 rounded-lg bg-white">
    <button
      v-for="tag in props.tags"
      :key="tag.id"
      type="button"
      class="flex items-center gap-2 px-3 py-1.5 rounded-full border transition-all text-sm font-medium"
      :class="selected.includes(tag.id)
        ? 'bg-brand text-white border-brand'
        : 'bg-gray-50 text-gray-600 border-gray-200 hover:border-brand hover:text-brand'"
      @click="toggle(tag.id)"
    >
      <CheckCircle2 :size="16" :class="selected.includes(tag.id) ? 'text-white' : 'text-gray-300'" />
      {{ tag.label }}
    </button>
  </div>
</template>
